<template>
  <div class="header-region" @mouseleave="mouseLeave()">
    <div class="showMore" v-show="showMore">
      <div :class="['moreTd',showIndex==5?'moreTdSelect':'']" @click="designerRight">设计师权益</div>
      <div :class="['moreTd',showIndex==6?'moreTdSelect':'']" @click="privacyFn">隐私政策</div>
    </div>
    <div class="header">
      <div class="header-tab">
        <img class="logo" src="../../../static/image/login/logo.png" alt />
      </div>

      <div class="header-list">
        <div
          class="tr"
          :class="showIndex==index?'showTr':''"
          @click="showTab(item)"
          v-for="(item,index) in headerList"
          :key="index"
        >
          <div>
            {{item.name}}
<!--            <div v-if="index==1" class="msgNumber">99+</div>-->
          </div>
          <div v-if="index<headerList.length-1" class="division"></div>
        </div>
        <div class="more" @mouseover="mouseOver">•••</div>
      </div>

      <div class="header-tab">
        <div class="imgList" v-for="(item,index) in imgList" :key="index">
          <img src="../../../static/image/commonIcon/msg.png" @click="showTab(item)" alt v-if="item.index==6"/>
          <img :src="item.imgUrl" @click="showTab(item)" alt v-else-if="item.index==7&&item.imgUrl" style="border-radius: 50%"/>
          <img src="../../../static/image/commonIcon/userImg.png" @click="showTab(item)" v-else alt style="border-radius: 50%"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {baseImgUrl} from "../../api/config"
export default {
  name: "headerRegion",
  props: ["isShowIndex"],
  data() {
    return {
      headerList: [
        {
          index: 0,
          name: "首页",
          pageUrl: "/home/home",
        },
        {
          index: 1,
          name: "任务",
          pageUrl: "/task/task",
        },
        {
          index: 2,
          name: "大厅",
          pageUrl: "/hall/hall",
        },
        {
          index: 3,
          name: "平台介绍",
          pageUrl: "/home/richText?pageType=justDetail&id=2",
        },
        {
          index: 4,
          name: "工作流程",
          pageUrl: "/home/richText?pageType=justDetail&id=9",
        },
      ],
      imgList: [
        // {
        //   imgUrl: "/static/image/commonIcon/serch.png",
        //   index: 5,
        //   pageUrl:'',
        // },
        {
          imgUrl: "../../../static/image/commonIcon/msg.png",
          index: 6,
          pageUrl:'/home/newsInfo',
        },
        {
          imgUrl: "",
          index: 7,
          pageUrl:'/userInfo/userInfo',
        },
      ],
      showIndex: 0,
      showMore: false,
      baseImgUrl:baseImgUrl,
      headPicture:"",
    };
  },
  created() {
    this.showIndex = this.isShowIndex || 0;
    this.getUserInfo();
    //headPicture
    // let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    // this.headPicture=userInfo.headPicture;
    // if(this.headPicture!=''&&this.headPicture!=null){
    //   this.imgList[1].imgUrl=this.headPicture.indexOf('http')>-1?this.headPicture:this.baseImgUrl+this.headPicture;
    // }
  },
  watch: {
    $route: function (to, from) {
      this.showIndex = this.isShowIndex || 0;
    }
  },
  methods: {
    async  getUserInfo(){   //获取头像
      if(localStorage.getItem('token')){
        let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        try {
          const res = await this.$http.getDetails(userInfo.id)
          console.log(res)
          if (res.code == 200) {
            if(res.result.headPicture){
              this.imgList[1].imgUrl=res.result.headPicture.indexOf('http')>-1?res.result.headPicture:this.baseImgUrl+res.result.headPicture;
            }
          } else {
            this.$message(res.message);
          }
        } catch (e) {

          throw e
        }
      }

    },
    privacyFn(){
      this.$router.push({
        path: "/home/richText",
        query:{
          pageType:"justDetail",
          id:1
        }
      });
    },
    designerRight(){
      this.$router.push({
        path: "/home/richText",
        query:{
          pageType:"justDetail",
          id:4
        }
      });
    },
    showTab(item) {
      console.log(this.$route.query.share)
      console.log(item);
      if(localStorage.getItem('token')){
        if (!item.pageUrl) {
          return false;
        }
        this.$router.push({
          path: item.pageUrl,
        });
      }else{
        this.$router.push({path:'/login/register'})
      }



    },
    mouseOver(e) {
      // console.log("放上去");
      this.showMore = true;
    },
    mouseLeave(e) {
      // console.log("移开");
      this.showMore = false;
    },
  },
};
</script>


<style scoped>
.header-region {
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.11);
  opacity: 1;
  height: 76px;
  position: fixed;
  top: 0;
  z-index: 999;
}
.header {
  margin: 20px auto 0;
  width: 1186px;
  /*width: 62%;*/
  /*padding: 0 19%;*/
  display: flex;
  align-content: center;
  /* justify-content: space-around; */
  justify-content: space-between;
}
.header-list {
  display: flex;
  align-content: center;
}
.tr {
  margin: 0 36px;
  display: flex;
  align-content: center;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 33px;
  color: #3a3a3a;
  opacity: 0.89;
  cursor: pointer;
}
.showTr {
  color: #dfb876;
}
.division {
  width: 0px;
  height: 17px;
  border: 1px solid #9e9e9e;
  display: inline-block;
  position: relative;
  left: 36px;
  top: 7px;
  opacity: 0.2;
}
.msgNumber {
  font-size: 10px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 33px;
  color: #ffffff;
  opacity: 1;
  background: #d83f3f;
  border-radius: 8px;
  position: absolute;
  top: 19px;
  height: 15px;
  width: 25px;
  line-height: 15px;
  text-align: center;
  margin: 0 0 0 25px;
}
.imgNumber {
  margin: 0 0 0 65px;
}
.header-tab {
  display: flex;
  align-content: center;
}
.imgList img {
  width: 35px;
  height: 35px;
  margin: 0 0 0 40px;
  cursor: pointer;
}
.logo {
  width: 142px;
  height: 40px;
  /*width: 76px;*/
  /*height: 36px;*/
}
.more {
  position: relative;
  top: 8px;
  cursor: pointer;
}
.showMore {
  position: absolute;
  background: #ffffff;
  border: 0.5px solid #dfdfdf;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 33px;
  color: #3a3a3a;
  margin: 75.5px 0 0 61%;
  padding: 0px 56px 0 19px;
}
.moreTd {
  margin: 12px 0px;
  cursor: pointer;
}
.moreTdSelect{
  color: #dfb876;
}
</style>



// WEBPACK FOOTER //
// src/components/headerRegion/headerRegion.vue